var map = {
	"./033-bm.webp": 1226,
	"./033-cn.webp": 1227,
	"./033.webp": 1228,
	"./13-bm.webp": 1229,
	"./13-cn.webp": 1230,
	"./13.webp": 1231,
	"./3-bm.webp": 1232,
	"./3-cn.webp": 1233,
	"./3.webp": 1234,
	"./angpao-bg-mobile.jpg": 1235,
	"./angpao-bg.jpg": 1236,
	"./angpao-bm.webp": 1237,
	"./angpao-cn.webp": 1238,
	"./angpao.webp": 1239,
	"./button.png": 1240,
	"./close-eye.png": 1241,
	"./coin-1.png": 1242,
	"./coin.png": 1243,
	"./ketupak-open.png": 1244,
	"./ketupak.png": 1245,
	"./ketupak_ribbon.png": 1246,
	"./rain-1.png": 1247,
	"./rain-2.png": 1248,
	"./rain-3.png": 1249,
	"./raya-bg-mobile.png": 1250,
	"./raya-bg.png": 1251,
	"./shine.png": 1252,
	"./star-1.png": 1253,
	"./star-2.png": 1254
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 458;